import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { CurrentUserService } from '@services/currentUser.service';
import { Payment } from '@modules/payments/Domain/payment.model';
import { PipeModule } from '@shared/pipes/pipe.module';
import { Button } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { PAYMENT_METHODS } from '@models/global-entities.model';
import { PaymentGateway } from '@shared/constants/gateway';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentMethod } from '@shared/constants/payment-method';

@Component({
  selector: 'app-payment-details',
  standalone: true,
  imports: [NgIf, DividerModule, PipeModule, Button, RouterLink, NgForOf, TranslateModule],
  templateUrl: './payment-details.component.html',
  styleUrl: './payment-details.component.scss',
})
export class PaymentDetailsComponent implements OnInit {
  @Input() payment!: Payment;
  @Output() closeModal = new EventEmitter<void>();

  private currentUser = inject(CurrentUserService);
  protected readonly PAYMENT_METHODS = PaymentMethod;

  // Signals
  loading = signal(true);
  error = signal<string | null>(null);

  ngOnInit(): void {}

  goToClient(id: string) {
    window.open(
      `/customers/customer/${id}?tenant=${this.currentUser.currentUser.tenantId}`,
      '_blank',
    );
  }

  goToOperation(id: string) {
    window.open(
      `/operations/operation/${id}?tenant=${this.currentUser.currentUser.tenantId}`,
      '_blank',
    );
  }
}
